import React, {createContext, use} from "react";
import PropTypes from "prop-types";
import {InMemoryCache} from "@apollo/client";

const RegScoutGraphQLClientCacheContext = createContext();

const regScoutCache = new InMemoryCache();

export const RegScoutGraphQLClientCacheProvider = ({children}) => {
  return (
    <RegScoutGraphQLClientCacheContext value={regScoutCache}>
      {children}
    </RegScoutGraphQLClientCacheContext>
  );
};

export const useRegScoutGraphQLClientCache = () => {
  return use(RegScoutGraphQLClientCacheContext);
};

RegScoutGraphQLClientCacheProvider.propTypes = {
  children: PropTypes.any,
};
